// modules
import { createAction } from 'redux-actions'
// setup
import { dispatch } from '$setup/redux'

// reducer
export const SET_WINDOW_DIMENSION = 'SET_WINDOW_DIMENSION'
export const setWindowDimension = createAction(
  SET_WINDOW_DIMENSION,
  (width, height) => ({ width, height }),
)
export const dispatchSetWindowDimension = (...args) =>
  dispatch(setWindowDimension(...args))

export const SET_WINDOW_FOCUS = 'SET_WINDOW_FOCUS'
export const setWindowFocus = createAction(SET_WINDOW_FOCUS, value => ({
  value,
}))
export const dispatchSetWindowFocus = (...args) =>
  dispatch(setWindowFocus(...args))

export const SET_LOADED = 'SET_LOADED'
export const setLoaded = createAction(SET_LOADED, loaded => ({ loaded }))
export const dispatchSetLoaded = (...args) => dispatch(setLoaded(...args))

export const SET_PERMISSIONS = 'SET_PERMISSIONS'
export const setPermissions = createAction(SET_PERMISSIONS)
export const dispatchSetPermissions = (...args) =>
  dispatch(setPermissions(...args))

export const SET_CONNECTION_STATUS = 'SET_CONNECTION_STATUS'
export const setConnectionStatus = createAction(SET_CONNECTION_STATUS)
export const dispatchSetConnectionStatus = (...args) =>
  dispatch(setConnectionStatus(...args))

export const SET_IS_MULTI_TAB = 'SET_IS_MULTI_TAB'
export const setIsMultiTab = createAction(SET_IS_MULTI_TAB)
export const dispatchSetIsMultiTab = (...args) =>
  dispatch(setIsMultiTab(...args))

export const SET_SENDFIELD_HEIGHT = 'SET_SENDFIELD_HEIGHT'
export const setSendFieldHeight = createAction(SET_SENDFIELD_HEIGHT)
export const dispatchSetSendFieldHeight = (...args) =>
  dispatch(setSendFieldHeight(...args))
